"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _Element = _interopRequireDefault(require("../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../01_atoms/ElementGroup"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BillingDetails = function BillingDetails() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      sdk = _ref.sdk,
      title = _ref.title,
      subtitle = _ref.subtitle,
      elementStyle = _ref.elementStyle,
      onEdit = _ref.onEdit,
      onEditLink = _ref.onEditLink,
      _ref$highlightEditBut = _ref.highlightEditButton,
      highlightEditButton = _ref$highlightEditBut === void 0 ? false : _ref$highlightEditBut,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator;

  return /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: title,
    subtitle: subtitle
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], {
    style: elementStyle
  }, sdk.billingDetails.areBillingDetailsValid() ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontWeight: 'bold',
      paddingRight: 10
    }
  }, t('Billing this trip to: ')), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      textAlign: 'justify'
    }
  }, "".concat(sdk.billingDetails.getBillingDetails().firstName, " ").concat(sdk.billingDetails.getBillingDetails().lastName), /*#__PURE__*/_react["default"].createElement("br", null), sdk.types.addressToString(sdk.billingDetails.getBillingDetails().address))) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: _Colors.discreetTextColor
    }
  }, t('Please enter your billing details.')), (onEditLink || onEdit) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    id: "edit-billing-details-button",
    to: onEditLink,
    onClick: onEdit,
    fluid: true,
    primary: highlightEditButton,
    style: {
      marginTop: 20
    }
  }, t('Edit billing information'))));
};

var _default = BillingDetails;
exports["default"] = _default;